var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col" },
    [
      _c(
        "el-descriptions",
        {
          staticClass: "description",
          attrs: { "label-class-name": "desc-label", column: 3, border: "" },
        },
        [
          _c("el-descriptions-item", { attrs: { label: "药库编码" } }, [
            _vm._v(
              " " + _vm._s(_vm.pageData.prescription.head["positionCode"]) + " "
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "药库名称" } }, [
            _vm._v(
              " " + _vm._s(_vm.pageData.prescription.head["positionName"]) + " "
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "加工方式" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm._f("SERVE_FEE_SIGN")(
                    _vm.pageData.prescription.head["serveFeeSign"]
                  )
                ) +
                " "
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "总剂数" } }, [
            _vm._v(
              " " + _vm._s(_vm.pageData.prescription.head["doseNum"]) + " "
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "次/日" } }, [
            _vm._v(
              " " + _vm._s(_vm.pageData.prescription.head["dayNum"]) + " "
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "剂/日" } }, [
            _vm._v(
              " " + _vm._s(_vm.pageData.prescription.head["dayFreq"]) + " "
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "ik-list-table",
          attrs: {
            stripe: true,
            border: true,
            data: _vm.pageData.prescription.body.chmedPrescriptionItem,
            height: 300,
            "highlight-current-row": true,
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "药品编码", prop: "materielName" },
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "品质标识", prop: "qualitySign" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("QUALITY_SIGN")(scope.row["qualitySign"])
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "单剂数量", prop: "singleNum" },
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "煎法", prop: "decoctionName" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }